import type { SpanContext } from '@opentelemetry/api';
import { context, isSpanContextValid, trace } from '@opentelemetry/api';

interface Carrier {
  traceparent?: string;
  tracestate?: string;
}

const getSpanContext = (): SpanContext | undefined => {
  const span = trace.getSpan(context.active());
  if (!span) return undefined;

  const spanContext = span.spanContext();
  if (!isSpanContextValid(spanContext)) return undefined;

  return spanContext;
};

const getTraceId = (): string | undefined => {
  const spanContext = getSpanContext();
  return spanContext?.traceId;
};

const getSpanId = (): string | undefined => {
  const spanContext = getSpanContext();
  return spanContext?.spanId;
};

export type { Carrier };
export { getSpanId, getTraceId };
